module.exports = __webpack_public_path__ + "img/articulos5.33d02416.png";